// image url builders shared by the stores and the server meta middleware

// the api returns a missing image as 'None'
export const presentImage = (value) => (value && value !== 'None' ? value : '')

export const basename = (path) => {
  let parts = path.split('/')
  if (parts.length) {
    return parts[parts.length - 1]
  }
  return null
}

const cdnImageUrl = (siteConfig, imageName) =>
  `${siteConfig.features.cdn.url}/library/system/${imageName}?width=986&height=740&fit=cover&enlarge=0&metadata=0`

export const classImageUrl = (imageUrl, siteConfig) => {
  let url
  imageUrl = presentImage(imageUrl)
  if (imageUrl) {
    const imageName = basename(imageUrl)
    if (siteConfig.features?.cdn?.url) {
      // if (siteConfig.features.cdn.type === 'keycdn') {
      url = cdnImageUrl(siteConfig, imageName)
    } else {
      url = `${siteConfig.legacyImagesBaseUrl}/system/${imageName}`
    }
  } else {
    url = `/sites/${siteConfig.key}/${siteConfig.assets.defaultClassImage || siteConfig.assets.logo}`
  }
  return url
}

export const legacyImageUrl = (imageUrl, siteConfig, defaultLocalFile = siteConfig.org.logoFilename) => {
  let url = `/sites/${siteConfig.key}/${defaultLocalFile}`
  imageUrl = presentImage(imageUrl)
  if (imageUrl) {
    const imageName = basename(imageUrl)
    if (siteConfig.features?.cdn?.url) {
      // if (siteConfig.features.cdn.type === 'keycdn') {
      url = cdnImageUrl(siteConfig, imageName)
    } else {
      url = imageUrl.includes('artist')
        ? `${siteConfig.legacyImagesBaseUrl}/artist/${imageName}`
        : imageUrl.includes('system/')
        ? `${siteConfig.legacyImagesBaseUrl}/system/${imageName}`
        : `${siteConfig.legacyImagesBaseUrl}/${imageName}`
    }
  }
  return url
}

export const eventImageUrl = (event, siteConfig) =>
  event.image?.itemImageFile
    ? `${siteConfig.legacyImagesBaseUrl}/system${event.image.itemImageFile}`
    : `/sites/${siteConfig.key}/${
        siteConfig.assets.defaultEventImage || siteConfig.assets.defaultClassImage || siteConfig.assets.logo
      }`
